import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Layout } from '../components/layout/Layout';
import { useApp } from '../context/AppContext';
import { Loader2 } from 'lucide-react';

const GenericPage = () => {
  const { slug } = useParams();
  const { API, getLocalizedText } = useApp();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const response = await fetch(`${API}/page/${slug}`);
        if (!response.ok) throw new Error('Page not found');
        const data = await response.json();
        setPage(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchPage();
  }, [slug, API]);

  if (loading) {
    return (
      <Layout>
        <div className="min-h-screen flex items-center justify-center">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
        </div>
      </Layout>
    );
  }

  if (error || !page) {
    return (
      <Layout>
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-800 mb-2">Page Not Found</h1>
            <p className="text-gray-600">The page you're looking for doesn't exist.</p>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-heading font-bold text-[#1A1625] mb-8">
          {getLocalizedText(page.title)}
        </h1>
        {/* Check if content contains HTML tags */}
        {getLocalizedText(page.content).includes('<') ? (
          <div 
            className="prose prose-lg max-w-none text-foreground prose-headings:font-heading [&_table]:w-full [&_table]:border-collapse [&_th]:bg-primary/10 [&_th]:text-primary [&_th]:font-semibold [&_th]:px-4 [&_th]:py-3 [&_th]:border [&_th]:border-gray-200 [&_td]:px-4 [&_td]:py-3 [&_td]:border [&_td]:border-gray-200 [&_tr:nth-child(even)]:bg-gray-50"
            dangerouslySetInnerHTML={{ 
              __html: getLocalizedText(page.content)
            }}
          />
        ) : (
          <div 
            className="prose prose-lg max-w-none text-foreground prose-headings:font-heading"
            dangerouslySetInnerHTML={{ 
              __html: getLocalizedText(page.content)
                .split('\n\n').map(p => `<p>${p.replace(/\n/g, '<br/>')}</p>`).join('')
            }}
          />
        )}
      </div>
    </Layout>
  );
};

export default GenericPage;
